module.exports = __webpack_public_path__ + "static/media/logo-k.da29f97d.png";